import { Component, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { map, combineLatest, filter } from 'rxjs';
import { MCProgressBarComponent, MCStepsComponent } from '@maslul/common-components';
import { ProgressService } from '../../../services/shared/progress';

@Component({
    selector: 'mi-app-progress',
    imports: [
        CommonModule,
        MCProgressBarComponent,
        MCStepsComponent
    ],
    templateUrl: './progress.html',
    styleUrls: ['./progress.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AppProgressComponent {
    progressValue$;
    currentStep$;
    totalSteps$;
    activeTabs$;
    currentTabIndex$;
    currentTabTitle: any;

    constructor(
        private progressService: ProgressService
    ) {
        //this.activeTabs$ = this.progressService.activeTabs$;

        this.activeTabs$ = combineLatest([
            this.progressService.activeTabs$,
            this.progressService.currentStep$
        ])
            .pipe(
                filter(([items]) => items.length !== 0),  
                map(([items, activeIndex]) => {
                return items.map((item, index) => {
                    this.currentTabTitle = items[activeIndex - 1].label;

                    if ((index + 1) < activeIndex) {
                        return { ...item, styleClass: 'mi-completed' };//error back
                    }
                    return { ...item, styleClass: '' };
                });
            })
            );

        this.currentStep$ = this.progressService.currentStep$;

        this.totalSteps$ = this.progressService.activeTabs$.pipe(
            map(tabs => tabs.length),
        );

        this.currentTabIndex$ = this.progressService.currentStep$;

        this.progressValue$ = combineLatest([this.currentStep$, this.totalSteps$]).pipe(
            map(([current, total]) => {
                return total > 0 ? (current / total) * 100 : 0
            }
            )

        );
    }


}
